import _ from 'lodash';
import { API_TYPE, API_V2_PREFIX } from '../../../constants/constants';

export const ACTIONS = {
  ADD_LOCATION: 'ADD_LOCATION',
  REMOVE_LOCATION: 'REMOVE_LOCATION',
  UPDATE_CMF: 'UPDATE_CMF',
  UPDATE_DMS: 'UPDATE_DMS',
};

export const getActiveSubscriptions = ({ api, connections, accessGrants }) => {
  const { id, type } = api;
  if (type === API_TYPE.REST) {
    const apiId = API_V2_PREFIX + id;
    return (
      connections?.[apiId]?.filter((f) => f.connectionStatus === 'active') || []
    );
  } else {
    return (
      accessGrants?.[id]?.filter((f) => f.accessGrantStatus === 'enabled') || []
    );
  }
};

export const groupByEntityId = (subscriptions) => {
  return subscriptions.reduce((acc, sub) => {
    const entityId = sub.orgId || sub.dataOwnerOrgId;
    acc[entityId] = sub;
    return acc;
  }, {});
};

export const manageSubscriptionUtil = ({
  subscribeRequest,
  unsubscribeRequest,
  existingSubcriptions,
  locationData,
  cmf,
  dmsConfig,
  action,
}) => {
  let updatedSubReq = subscribeRequest;
  let updatedUnSubReq = unsubscribeRequest;
  const locId = locationData.entityId;
  const newSubReq = { ...subscribeRequest };
  const newUnsubReq = { ...unsubscribeRequest };
  let updated = false;
  switch (action) {
    case ACTIONS.ADD_LOCATION:
      if (!newSubReq.hasOwnProperty(locId)) {
        newSubReq[locId] = locationData;
        updated = true;
      }
      break;
    case ACTIONS.REMOVE_LOCATION:
      if (newSubReq.hasOwnProperty(locId)) {
        delete newSubReq[locId];
        updated = true;
      }
      break;
    case ACTIONS.UPDATE_CMF:
      if (newSubReq.hasOwnProperty(locId)) {
        const existingSubReq = newSubReq[locId];
        if (existingSubReq.cmfNumber !== cmf) {
          newSubReq[locId] = { ...existingSubReq, cmfNumber: cmf };
          updated = true;
        }
      }
      break;
    case ACTIONS.UPDATE_DMS:
      let existingSubReq = newSubReq[locId];
      // updating DMS of already subscribed location
      if (!existingSubReq) {
        const { orgId, cmf, dms } = existingSubcriptions[locId];
        let dmsConfig = [];
        if (Array.isArray(dms)) dmsConfig = dms;
        existingSubReq = {
          entityId: orgId,
          cmfNumber: cmf,
          dmsConfig,
        };
      }
      // add this to current subscribe request only if there is a change in DMS
      if (!_.isEqual(existingSubReq.dmsConfig, dmsConfig)) {
        newSubReq[locId] = { ...existingSubReq, dmsConfig };
        updated = true;
      }
      break;
    default:
      console.error('unknown action:', action);
  }
  updatedSubReq = updated ? newSubReq : subscribeRequest;

  if (action === ACTIONS.ADD_LOCATION || action === ACTIONS.REMOVE_LOCATION) {
    updated = false;
    switch (action) {
      case ACTIONS.ADD_LOCATION:
        if (newUnsubReq.hasOwnProperty(locId)) {
          delete newUnsubReq[locId];
          updated = true;
        }
        break;
      case ACTIONS.REMOVE_LOCATION:
        if (existingSubcriptions[locId]) {
          newUnsubReq[locId] = locationData;
          updated = true;
        }
        break;
      default:
        console.error('unknown action:', action);
    }
    updatedUnSubReq = updated ? newUnsubReq : unsubscribeRequest;
  }
  return { updatedSubReq, updatedUnSubReq };
};

export const DAAB_ADD_LOCATIONS_STEPS = {
  SELECT_LOCATION: 'Select Locations',
  SELECT_DMS: 'Select Departments and DMS',
  REVIEW_ACTIVATION: 'Review Activation',
};
